import * as React from 'react'; 
import { any, func } from 'prop-types';

import Button from '../Button';
import { dayToLabel } from '../../utils/day-to-label';

export default function WeeklyNavigation({startDate, endDate, onRequestNext, onRequestPrev}){
   return (
     <div className="flex items-center">
       <div className="mr-3">
         <div className="inline-block mr-2">
           <button className="rounded shadow bg-white px-2 rounded-full" onClick={onRequestPrev}>
             &larr;
           </button>
         </div>
         <div className="inline-block">
           <button className="rounded shadow bg-white px-2 rounded-full" onClick={onRequestNext}>
             &rarr;
           </button>
         </div>
       </div>
       <div>
         {dayToLabel(startDate.getDay())}, {startDate.getDate()}/{startDate.getMonth() + 1} -  {dayToLabel(endDate.getDay())}, {endDate.getDate()}/{endDate.getMonth() + 1}
       </div>
     </div>
   );
}

WeeklyNavigation.defaultProps = {
  startDate: new Date(),
  endDate: new Date(), 
}

WeeklyNavigation.propTypes = {
  startDate: any,
  endDate: any,
  onRequestNext: func,
  onRequestPrev: func, 
}
